export default "__VITE_ASSET__60c3dc73__"